// extracted by mini-css-extract-plugin
export default {"goBack":"createConfig_goBack__5tWhy","form":"createConfig_form__C-0OD"};